/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Pulse_Badge_OfferInputs */

const id_home_pulse_badge_offer = /** @type {(inputs: Home_Pulse_Badge_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penawaran`)
};

const ms_home_pulse_badge_offer = /** @type {(inputs: Home_Pulse_Badge_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tawaran`)
};

const da_home_pulse_badge_offer = /** @type {(inputs: Home_Pulse_Badge_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilbud`)
};

const de_home_pulse_badge_offer = /** @type {(inputs: Home_Pulse_Badge_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angebot`)
};

const en_us2_home_pulse_badge_offer = /** @type {(inputs: Home_Pulse_Badge_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offer`)
};

const es_es2_home_pulse_badge_offer = /** @type {(inputs: Home_Pulse_Badge_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catálogo`)
};

const es_mx2_home_pulse_badge_offer = /** @type {(inputs: Home_Pulse_Badge_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferta`)
};

const fil_home_pulse_badge_offer = /** @type {(inputs: Home_Pulse_Badge_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offer`)
};

const fr_home_pulse_badge_offer = /** @type {(inputs: Home_Pulse_Badge_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offre`)
};

const it_home_pulse_badge_offer = /** @type {(inputs: Home_Pulse_Badge_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offerta`)
};

const hu_home_pulse_badge_offer = /** @type {(inputs: Home_Pulse_Badge_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajánlat`)
};

const nl_home_pulse_badge_offer = /** @type {(inputs: Home_Pulse_Badge_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aanbod`)
};

const no_home_pulse_badge_offer = /** @type {(inputs: Home_Pulse_Badge_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilbud`)
};

const pl_home_pulse_badge_offer = /** @type {(inputs: Home_Pulse_Badge_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferta`)
};

const pt_br2_home_pulse_badge_offer = /** @type {(inputs: Home_Pulse_Badge_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catálogo`)
};

const pt_home_pulse_badge_offer = /** @type {(inputs: Home_Pulse_Badge_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferta`)
};

const ro_home_pulse_badge_offer = /** @type {(inputs: Home_Pulse_Badge_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ofertă`)
};

const fi_home_pulse_badge_offer = /** @type {(inputs: Home_Pulse_Badge_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarjous`)
};

const sv_home_pulse_badge_offer = /** @type {(inputs: Home_Pulse_Badge_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erbjudande`)
};

const vi_home_pulse_badge_offer = /** @type {(inputs: Home_Pulse_Badge_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ưu đãi`)
};

const tr_home_pulse_badge_offer = /** @type {(inputs: Home_Pulse_Badge_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teklif`)
};

const cs_home_pulse_badge_offer = /** @type {(inputs: Home_Pulse_Badge_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nabídka`)
};

const bg_home_pulse_badge_offer = /** @type {(inputs: Home_Pulse_Badge_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оферта`)
};

const ru_home_pulse_badge_offer = /** @type {(inputs: Home_Pulse_Badge_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предложение`)
};

const uk_home_pulse_badge_offer = /** @type {(inputs: Home_Pulse_Badge_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пропозиція`)
};

const ar_home_pulse_badge_offer = /** @type {(inputs: Home_Pulse_Badge_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عرض`)
};

const hi_home_pulse_badge_offer = /** @type {(inputs: Home_Pulse_Badge_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑफ़र`)
};

const th_home_pulse_badge_offer = /** @type {(inputs: Home_Pulse_Badge_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ข้อเสนอ`)
};

const ja_home_pulse_badge_offer = /** @type {(inputs: Home_Pulse_Badge_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オファー`)
};

const zh_cn2_home_pulse_badge_offer = /** @type {(inputs: Home_Pulse_Badge_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目录项`)
};

const zh_hant1_home_pulse_badge_offer = /** @type {(inputs: Home_Pulse_Badge_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目錄項目`)
};

const ko_home_pulse_badge_offer = /** @type {(inputs: Home_Pulse_Badge_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`오퍼`)
};

/**
* | output |
* | --- |
* | "Offer" |
*
* @param {Home_Pulse_Badge_OfferInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_pulse_badge_offer = /** @type {((inputs?: Home_Pulse_Badge_OfferInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Pulse_Badge_OfferInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_pulse_badge_offer(inputs)
	if (locale === "ms") return ms_home_pulse_badge_offer(inputs)
	if (locale === "da") return da_home_pulse_badge_offer(inputs)
	if (locale === "de") return de_home_pulse_badge_offer(inputs)
	if (locale === "en-US") return en_us2_home_pulse_badge_offer(inputs)
	if (locale === "es-ES") return es_es2_home_pulse_badge_offer(inputs)
	if (locale === "es-MX") return es_mx2_home_pulse_badge_offer(inputs)
	if (locale === "fil") return fil_home_pulse_badge_offer(inputs)
	if (locale === "fr") return fr_home_pulse_badge_offer(inputs)
	if (locale === "it") return it_home_pulse_badge_offer(inputs)
	if (locale === "hu") return hu_home_pulse_badge_offer(inputs)
	if (locale === "nl") return nl_home_pulse_badge_offer(inputs)
	if (locale === "no") return no_home_pulse_badge_offer(inputs)
	if (locale === "pl") return pl_home_pulse_badge_offer(inputs)
	if (locale === "pt-BR") return pt_br2_home_pulse_badge_offer(inputs)
	if (locale === "pt") return pt_home_pulse_badge_offer(inputs)
	if (locale === "ro") return ro_home_pulse_badge_offer(inputs)
	if (locale === "fi") return fi_home_pulse_badge_offer(inputs)
	if (locale === "sv") return sv_home_pulse_badge_offer(inputs)
	if (locale === "vi") return vi_home_pulse_badge_offer(inputs)
	if (locale === "tr") return tr_home_pulse_badge_offer(inputs)
	if (locale === "cs") return cs_home_pulse_badge_offer(inputs)
	if (locale === "bg") return bg_home_pulse_badge_offer(inputs)
	if (locale === "ru") return ru_home_pulse_badge_offer(inputs)
	if (locale === "uk") return uk_home_pulse_badge_offer(inputs)
	if (locale === "ar") return ar_home_pulse_badge_offer(inputs)
	if (locale === "hi") return hi_home_pulse_badge_offer(inputs)
	if (locale === "th") return th_home_pulse_badge_offer(inputs)
	if (locale === "ja") return ja_home_pulse_badge_offer(inputs)
	if (locale === "zh-CN") return zh_cn2_home_pulse_badge_offer(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_pulse_badge_offer(inputs)
	return ko_home_pulse_badge_offer(inputs)
});
export { home_pulse_badge_offer as "home.pulse.badge.offer" }